import { useRouter } from 'next/router'
import { useState } from 'react'
import { StyledPWithADWrap } from './PWithADWrap.style'
import { StyledP } from './ContentParser.style'
import { DesktopAdId, MobileAdId } from '../../contexts'
import { IPWithAds } from './types'
import { PocTaboolaPageType, PocTaboolaSuffixId, Taboola } from '../Taboola'
import { Ad } from '../../sharedComponnets'

const midArticleTaboola = (isArticleVod: boolean) => (
  <Taboola
    pageType={
      isArticleVod ? PocTaboolaPageType.article_vod : PocTaboolaPageType.article
    }
    suffixId={PocTaboolaSuffixId.midArticle}
  />
)

export const PWithADWrap = ({
  for_key,
  html,
  cls,
  adId,
  fallBackAdId,
  addType = 'dfp',
  isArticleVod,
}: IPWithAds) => {
  const [state_id, setAdId] = useState(adId)
  const router = useRouter()
  // const [adWidth, setAdWidth] = useState(0)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleRender = (e: any) => {
    if (e.isEmpty && fallBackAdId) {
      setAdId(fallBackAdId)
    }
  }

  return (
    <StyledPWithADWrap key={`${state_id}-${for_key}-${router.asPath}`}>
      <StyledP dangerouslySetInnerHTML={{ __html: html }} className={cls} />
      {addType === 'dfp' ? (
        <Ad
          desktopAdId={state_id as DesktopAdId}
          mobileAdId={state_id as MobileAdId}
          onRender={handleRender}
        />
      ) : (
        midArticleTaboola(isArticleVod)
      )}
    </StyledPWithADWrap>
  )
}
